module.exports = __webpack_public_path__ + "static/media/cafe24-stock-sub1.eb161454.png";